<template>
    <nav class="fixed w-screen bg-white fogg z-20">
        <section class="transparent shadow px-4 lg:px-8 xl:px-48 3xl:px-96 py-4">
            <div class="flex justify-between">
                <div class="flex space-x-3 my-auto">
                    <a href="#home"> 
                        <LeafIcon class="w-12 h-12 my-auto cursor-pointer"/>
                    </a>
                    <a href="/#home" class="my-auto">
                        <div class="my-auto flex cursor-pointer">
                            <span class="my-auto text-xl font-bold logo">Growth</span>
                            <span class="my-auto text-xl font-normal logo green">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                            </span>
                            <span class="my-auto text-xl font-bold logo">
                                Relief
                            </span>
                        </div>
                    </a>
                </div>
                <div class="my-auto hidden lg:flex">
                    <ul class="flex space-x-4 xl:space-x-6 my-auto relative top-0.5">
                        <li class="my-auto px-2 py-1">
                            <a href="/#why-donate" class="link pb-1.5">
                                Why Donate?
                            </a>
                        </li>
                        
                        <li class="my-auto">
                            <a href="/#therapy-fund" class="link pb-1.5">
                                Therapy Fund
                            </a>
                        </li>
                        <li class="my-auto px-2 py-1">
                            <a href="/#campaigns" class="link pb-1.5">
                                Client-Centered Campaigns
                            </a>
                        </li>
                        <li class="my-auto">
                            <a href="/#how-it-works" class="link pb-1.5">
                                How to Donate
                            </a>
                        </li>
                        <li class="my-auto">
                            <a 
                                target="_blank"
                                href="https://docs.google.com/forms/d/e/1FAIpQLSfkPXPLOujSHkZE7LfC7z8qs9JjGGOq0faWbI1YGvi28O44JQ/viewform" class="link pb-1.5">
                                Start Therapy
                            </a>
                        </li>
                    </ul>
                    <div class="pl-10 my-auto">
                        <router-link 
                            to="/donate"
                            class="rounded-md px-3 py-2 bg-black font-semibold shadow hover:bg-gray-900 text-dark-green flex space-x-2">
                            <span class="my-auto">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    class="h-6 w-6" 
                                    fill="none" 
                                    viewBox="0 0 24 24" 
                                    stroke="currentColor" 
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </span>
                            <span>
                                Donate
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="my-auto lg:hidden">
                    <button @click="showMobileMenu = !showMobileMenu">
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="h-7 w-7" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor" 
                            stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h8m-8 6h16" v-if="!showMobileMenu"/>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" v-if="showMobileMenu"/>
                        </svg>
                    </button>
                </div>
            </div>
        </section>
        <div class="w-full  fogg  shadow-lg rounded-b-xl lg:hidden" :class="{
            'transition-all ease-in-out duration-100 h-full' : showMobileMenu,
            'transition-all ease-in-out duration-100 h-0' : !showMobileMenu
            }">
            <ul class="my-auto py-4 px-10 space-y-4" :class="{'hidden' : !showMobileMenu, 'block' : showMobileMenu}">
                <li class="my-auto">
                    <a href="/#why-donate" class="link pb-1.5">
                        Why Donate?
                    </a>
                </li>
                <li class="my-auto">
                   <a href="/#therapy-fund" class="link pb-1.5">
                        Therapy Fund
                    </a>
                </li>
                <li class="my-auto">
                    <a href="/#campaigns" class="link pb-1.5">
                        Client-Centered Campaigns
                    </a>
                </li>
                <li class="my-auto">
                    <a href="/#how-it-works" class="link pb-1.5">
                        How to Donate
                    </a>
                </li>
                <li class="my-auto">
                    <a 
                        target="_blank"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSfkPXPLOujSHkZE7LfC7z8qs9JjGGOq0faWbI1YGvi28O44JQ/viewform" 
                        class="link pb-1.5">
                        Start Therapy
                    </a>
                </li>
            </ul>
            <div class="px-10 pb-4" :class="{'hidden' : !showMobileMenu, 'block' : showMobileMenu}">
                <router-link 
                    to="/donate"
                    class="rounded-md px-3 py-2 bg-black font-semibold shadow hover:bg-gray-900 text-dark-green flex space-x-2 justify-center">
                    <span class="my-auto">
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="h-6 w-6" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor" 
                            stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                    <span>
                        Donate
                    </span>
                </router-link>
            </div>
        </div>
    </nav>
</template>

<script>
import LeafIcon from '@/components/icons/LeafIcon'
export default {
    name: 'NavBar',
    components: {
        LeafIcon
    },
    data(){
        return {
            showMobileMenu: false
        }
    }
}
</script>

<style scoped>
    .green{
        color: #5ECE4A
    }

    .link {
        display: block;
        position: relative;
    }

    .link::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #34D399;
        opacity: 0;
        transition: opacity 300ms, transform 300ms;
    }

    .link:hover::after,
    .link:focus::after {
        opacity: 1;
        transform: translate3d(0, 0.2em, 0);
    }

    li .link::after {
        opacity: 0;
        transform: scale(0);
        transform-origin: center;
    }

    li .link:hover::after,
    li .link:focus::after{
        transform: scale(1);
    }

   .fogg{
        background-color: rgba(255, 255, 255, 0.65);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
    }

</style>